// App.jsx
import React from 'react';
import SDGSelection from '../components/SdgSelection';
import '../styles/sdg-selection.css';

const SdgSelectorPage = () => {
  return (
    <div className="container">
      <h3>Identify YOUR sustainability focus </h3>
      <SDGSelection />
    </div>
  );
};

export default SdgSelectorPage;
